import { useMutation } from "@tanstack/react-query";
import { uploadMigrationFile } from "@/shared/actions/campanas/migracion.actions";
import { toast } from "react-toastify";
import { toApiError } from "@/shared/utils/general";
import { queryClient } from "@/shared/query-client/query-client";

type CampaignType = "MIGRATION" | "FIDELIZATION";

interface UploadPayload {
  file: File;
  campaignType: CampaignType;
}

export const useUploadMigracion = () => {
  const mutation = useMutation({
    mutationFn: ({ file, campaignType }: UploadPayload) =>
      uploadMigrationFile(file, campaignType),

    onSuccess: (_response, variables) => {
      toast.success("Archivo cargado correctamente");

      queryClient.invalidateQueries({
        queryKey: ["migration-uploads"],
      });

      queryClient.invalidateQueries({
        queryKey: ["campaign-config-summary"],
      });

      if (variables.campaignType === "MIGRATION") {
        queryClient.invalidateQueries({
          queryKey: ["obsolete-candidates"],
        });
      }

      if (variables.campaignType === "FIDELIZATION") {
        queryClient.invalidateQueries({
          queryKey: ["fidelization-candidates"],
        });
      }

      queryClient.invalidateQueries({
        queryKey: ["available-ticket-candidates"],
      });
    },

    onError: (error) => {
      const data = toApiError(error);
      toast.error(data.message);
    },
  });

  return {
    upload: mutation.mutate,
    loading: mutation.isPending,
  };
};